export const vodafoneRed = '#e60000';
